import { Gallery } from "~/components/Gallery/Gallery";
import { ComponentGallery } from "~/components/ComponentGallery/ComponentGallery";
import { Button } from "@caesars-ui/core";
import * as React from 'react';
export default {
  Gallery,
  ComponentGallery,
  Button,
  React
};